<template>
  <div>
    <div
      class="alert alert-info alert-dismissible"
      v-if="configurations.check_in_desktop == 1 && user.access_nivel == 1"
    >
      <strong>ATENÇÃO!</strong> Botão de Check-In está desabilitado para o seu
      tipo de Usuário! Check-In somente pela leitura do QRcode.
    </div>
    <!-- Banner -->
    <section id="banner" class="parallax">
      <div class="wrapper bg-cover">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="card filter-home">
                <div class="col-md-2; left">
                  <vue-qrcode
                    class="photo-qrcode-position"
                    errorCorrectionLevel="L"
                    :value="schedule.place.id + ''"
                  />
                </div>
                <div class="card-body">
                  <div
                    class="row justify-content-center"
                    style="margin-top: 15px; padding-left: 110px"
                  >
                    <div class="col-md-11">
                      <label for="title">Estação de Trabalho</label>
                      <h5>
                        <span class="badge badge-default">{{
                          schedule.place.title
                        }}</span>
                      </h5>
                    </div>
                  </div>
                  <div
                    class="row justify-content-center"
                    style="margin-top: 25px; padding-left: 15px"
                  >
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="inputPlace">Data Início</label>
                        <h5>
                          <span class="badge badge-default">{{
                            schedule.date_start
                          }}</span>
                        </h5>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="inputPlace">Data Final</label>
                        <h5>
                          <span class="badge badge-default">{{
                            schedule.date_end
                          }}</span>
                        </h5>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="inputPlace">Status</label>
                        <h5 v-if="schedule.status == 1">
                          <span class="badge badge-default">Reservada</span>
                        </h5>
                        <h5 v-if="schedule.status == 2">
                          <span class="badge badge-primary">Confirmada</span>
                        </h5>
                        <h5 v-if="schedule.status == 3">
                          <span class="badge badge-success">Em andamento</span>
                        </h5>
                        <h5 v-if="schedule.status == 4">
                          <span class="badge badge-warning">Finalizada</span>
                        </h5>
                        <h5 v-if="schedule.status == 5">
                          <span class="badge badge-danger">Cancelada</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div
                  class="row"
                  style="padding-left: 30px"
                  v-if="
                    (loaded && schedule.status == 3) ||
                    (schedule.status == 4 && schedule.longitude_checkin != null)
                  "
                >
                  <div class="col-md-12 mb-3" style="font-size: 16px">
                    <strong>Latitude: {{ schedule.latitude_checkin }}</strong>
                  </div>
                  <div class="col-md-12 mb-3" style="font-size: 16px">
                    <strong>Longitude: {{ schedule.longitude_checkin }}</strong>
                  </div>
                  <div class="col-md-12 mb-3" style="font-size: 16px">
                    <strong
                      >Data e Horário do Check-In:
                      {{ schedule.checkin_date_f }}</strong
                    >
                  </div>
                  <div
                    class="col-md-12 mb-3"
                    style="font-size: 16px"
                    v-if="schedule.checkout_date != null"
                  >
                    <strong
                      >Data e Horário do Check-Out:
                      {{ schedule.checkout_date_f }}</strong
                    >
                  </div>
                  <div
                    class="col-md-12 mb-3"
                    style="font-size: 16px"
                    v-if="user.access_nivel == 2 || user.access_nivel == 3"
                  >
                    <strong
                      >IP do dispositivo do Usuário:
                      {{ schedule.ip_checkin }}</strong
                    >
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div
                    class="row"
                    v-if="
                      schedule.longitude_checkin != null && schedule.status != 5
                    "
                  >
                    <div class="col-md-12">
                      <GmapMap
                        v-if="loaded"
                        :center="center"
                        :zoom="17"
                        map-type-id="terrain"
                        style="width: 1050px; height: 600px"
                      >
                        <GmapMarker
                          :key="index"
                          v-for="(m, index) in markers"
                          :position="m.position"
                          :clickable="true"
                          :draggable="true"
                          @click="center = m.position"
                        />
                      </GmapMap>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <div class="row text-center">
                    <div
                      class="col"
                      v-if="configurations.select_button_room == 1"
                    >
                      <button
                        class="btn btn-success"
                        @click="checkInReserve"
                        :disabled="
                          configurations.check_in_desktop == 1 &&
                          user.access_nivel == 1
                        "
                      >
                        Check-in
                      </button>
                    </div>
                    <div class="col">
                      <button class="btn btn-warning" @click="finishReserve">
                        Finalizar
                      </button>
                    </div>
                    <div class="col">
                      <button class="btn btn-danger" @click="cancelReserve">
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="workstations">
      <div class="row justify-content-center">
        <h2 class="title justify-content-center">
          Estação de trabalho reservada
        </h2>
      </div>
      <div class="container-fluid">
        <div class="row justify-content-center">
          <!-- Workstation Card -->
          <div class="col-md-3">
            <div class="card">
              <img class="card-img-top" :src="schedule.workstation.photo" alt />

              <div class="card-body">
                <div class="workstation-name">
                  {{ schedule.place.title }}
                  <span class="workstation-distance">{{
                    schedule.place_id
                  }}</span>
                </div>
                <div class="workstation-info">
                  <div class="workstation-place">
                    {{ schedule.workstation.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <section id="banner" class="parallax" style="margin-top: 25px">
      <div class="wrapper bg-cover">
        <div class="container">
          <div class="row" align="center">
            <div class="col-md-12">
              <h5>Participantes</h5>
              <hr />
            </div>
          </div>
          <div class="row" style="margin-top: -25px; padding: 25px">
            <table class="table table-striped" style="width: 100%">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>E-mail</th>
                  <th>Status</th>
                  <th>QrCode</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="participant in schedule.participants"
                  :key="participant.id"
                >
                  <td width="40%">{{ participant.name }}</td>
                  <td width="40%">{{ participant.email }}</td>
                  <td width="20%">
                    <span
                      class="badge"
                      :class="
                        participant.status == 1
                          ? 'badge-warning'
                          : participant.status == 2
                          ? 'badge-success'
                          : 'badge-danger'
                      "
                      >{{
                        participant.status == 1
                          ? "Aguardando"
                          : participant.status == 2
                          ? "Confirmado"
                          : "Rejeitado"
                      }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import vSelect from "vue-select";
import VueQrcode from "vue-qrcode";

export default {
  data: function () {
    return {
      schedule: {
        workstation: [],
      },
      configurations: [],
      users: [],
      user: {},
      location: {},
      loaded: false,
      center: { lat: -23.4066115, lng: -46.7460003 },
      markers: [
        {
          position: {
            lat: -23.4066115,
            lng: -46.7460003,
          },
        }, // Along list of clusters
      ],
    };
  },
  components: { vSelect, VueQrcode },
  computed: {
    checkinDate() {
      return this.schedule.checkin_date;
    },
  },
  methods: {
    checkInReserve() {
      let self = this;
      let api = self.$store.getters.api + "schedule_workstations/checkin/";

      if (self.location.coords == undefined) {
        self.showPermissionDeniedSwal();
      } else {
        self.schedule.latitude_checkin = self.location.coords.latitude;
        self.schedule.longitude_checkin = self.location.coords.longitude;
        self.schedule.reserve_id = self.$route.params.id;

        if (self.schedule.status == 3 || self.schedule.checkin_date) {
          swal("Erro", "Esta reserva já possui check-in", "info");
        } else {
          self.$http
            .post(api, self.schedule)
            .then((response) => {
              self.$message(
                "Sucesso",
                "Reserva atualizada com sucesso!",
                "success"
              );
              // window.location.reload();
              self.getSchedule();
            })
            .then(() => {
              self.schedule.status = 3;
            })
            .catch((error) => {
              self.errors = error.response.data;
              self.$message(null, self.errors, "error");
            });
        }
      }
    },
    showPermissionDeniedSwal() {
      swal({
        title: "Permissão para acessar geolocalização",
        text:
          "Para realizar este processo, você precisa liberar o acesso à geolocalização, siga estes passos para desbloquear: \n\n" +
          "1 - Clique em Configurações\n" +
          "2 - Clique em Configurações do site\n" +
          "3 - Clique em Local\n" +
          "4 - Na lista de bloqueados procure por https://app.invitee.com.br clique sobre ele e na sequencia clique em Limpar e Redefinir \n" +
          "5 - Tente novamente",
        type: "info",
        closeOnConfirm: true,
      });
    },
    finishReserve() {
      let self = this;
      let api = self.$store.getters.api + "schedule_workstations/checkout/";

      if (self.schedule.status == 4 || self.schedule.checkout_date) {
        swal("Erro", "Esta reserva já possui check-out", "info");
      } else {
        self.$http
          .post(api, self.schedule, {
            reserve_id: self.$route.params.id,
          })
          .then((response) => {
            self.$message(
              "Sucesso",
              "Reserva atualizada com sucesso!",
              "success"
            );
            self.getSchedule();
          })
          .then(() => {
            v;
            self.schedule.status = 4;
          })
          .catch((error) => {
            self.errors = error.response.data;
            self.$message(null, self.errors, "error");
          });
      }
    },
    cancelReserve() {
      let self = this;
      let api =
        self.$store.getters.api +
        "schedule_workstations/" +
        self.$route.params.id;
      if (self.schedule.status == 5) {
        swal("Erro", "Esta reserva já foi cancelada", "info");
      } else {
        self.$http
          .put(api, {
            status: 5,
          })
          .then((response) => {
            self.$message(
              "Sucesso",
              "Reserva atualizada com sucesso!",
              "success"
            );
          })
          .then(() => {
            self.schedule.status = 5;
          });
      }
    },
    getConfigurations: function () {
      const self = this;
      const api = self.$store.state.api + "my-config/";

      self.$http
        .post(api)
        .then((response) => {
          self.configurations = response.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSchedule: function () {
      let self = this;
      self.loaded = false;
      let id = self.$route.params.id;
      let api =
        self.$store.state.api +
        "schedule_workstations/" +
        id +
        "/?with[]=workstation&with[]=participants&with[]=place";

      self.$http
        .get(api)

        .then((response) => {
          self.schedule = response.data.data[0];

          self.center.lat = Number(self.schedule.latitude_checkin);
          self.center.lng = Number(self.schedule.longitude_checkin);

          self.markers[0].position.lat = Number(self.schedule.latitude_checkin);
          self.markers[0].position.lng = Number(
            self.schedule.longitude_checkin
          );
          self.loaded = true;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted() {
    const self = this;
    if (!("geolocation" in navigator)) {
      this.errorStr = "Geolocation não disponível.";
      return;
    }

    this.gettingLocation = true;
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        console.log(pos);
        this.gettingLocation = false;
        this.location = pos;
      },
      (err) => {
        this.gettingLocation = false;
        this.errorStr = err.message;
        // alert(err.message);
      }
    );
    this.getConfigurations();
    this.getSchedule();
    setTimeout(function () {
      self.user = self.$store.getters.user;
    }, 1000);
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.left {
  position: absolute;
  margin-top: 30px;
  margin-right: 950px;
}

.lg-check {
  margin: 20px;
}

.lg-badge {
  margin: 3px;
}

.pointer {
  cursor: pointer;
}

.borderSelected {
  border: 2px solid #222;
  margin-bottom: 1rem;
  box-shadow: inset 0 0 1em #222, 0 0 1em #222;
}

.rowTable {
  border-bottom: 1px solid #222;
  padding: 3px;
  width: 100%;
}

.rowTable:hover {
  border-bottom: 1px solid #222;
  padding: 3px;
  width: 100%;
  background-color: #f0f0f0;
}

input[type="checkbox"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

input[type="checkbox"] + label {
  font-size: 12px;
  padding: 2px 0 0;
  width: 100%;
  max-height: 100%;
  border: 2px solid #2b2e2c;
  color: #424241;
  border-radius: 0.25rem;
}

input[type="checkbox"]:checked + label {
  border: 2px solid #474747;
  color: #fff;
  background-color: #474747;
  font-style: normal;
}

.photo-qrcode-position {
  width: 150px;
  height: 150px;
  margin-block: -18px;
}
</style>


// WEBPACK FOOTER //
// src/components/ScheduleWorkstations/View.vue